module.exports = __webpack_public_path__ + "img/video.2a48684e.svg";